import { FormattedMessage } from "react-intl";
import {toLower, isNil} from "lodash-es";

type Props = {
    id: string;
    defaultMessage: string;
    supplierModel?: any;
    isSupplierVendorOverride?: boolean;
    values?: any;
};

const OwTranslate = (props: Props) => {
    const isSupplierVendorOverride = props.isSupplierVendorOverride || false;

    let id: string = toLower(props.id);
    let defaultMessage = props.defaultMessage;

    if (isSupplierVendorOverride && !isNil(props.supplierModel.vendor_name_override)) {
        id = id.replace(/vendor/, props.supplierModel.vendor_name_override);
        defaultMessage = defaultMessage.replace(/Vendor/, props.supplierModel.vendor_name_override);
    }

    return (
        <FormattedMessage id={`${id}`} defaultMessage={`${defaultMessage}`} description={`${defaultMessage} Title`} values={props.values} />
    );
};

export default OwTranslate;
